<template>
  <div>
    <ThePageHeader :title="'Anyagleadás'" />

    <div class="text">
      <p>
        <b>Fájlformátum:</b><br>
        Nyomdakész CMYK Composite PDF Exportált PDF esetében: PDF/X-1a szabvány<br>
        Direktszínes anyagok esetében pedig PDF/X-4<br>
      </p>

      <p>
        <b>Képek:</b><br>
        CMYK, minimum 300 DPI, lehetőleg jpg tömörítés nélkül,
        beágyazva a pdf-be 1:1 méretarányban, kifutó 3 mm
      </p>

      <p>
        <b>Méretek:</b><br>
        A megrendelésben meghatározott méret szerint kérjük a leadott
        állományok méretezését. Kifutó esetén + 3-3 mm-es ráhagyást kérünk.
      </p>

      <p>
        <b>Betűtípusok:</b><br>
        Az állományban levő összes font legyen legörbézett,
        egyéb esetben csatolják a betűtípusokat.
      </p>

      <p>
        <b>Szöveg:</b><br>
        A tartalmi és nyelvtani hibákért, korrektúrázás, jóváhagyás
        után nem áll módunkban felelősséget vállalni.
      </p>

      <p>
        <b>Színek:</b><br>
        Kérjük, csak a ténylegesen nyomásra kerülő színek legyenek az anyagban,
        direkt színek alkalmazásakor kizárólag csakis a megfelelő elemek
        (objektumok, fontok, képek...) legyenek direkt színben megadva,
        melyek, a megrendelésben is direkt színként szerepelnek.<br>

        A felesleges direkt színeket kérjük CMYK-színrendszerbe átalakítani.<br>

        UV-lakk, effektlakk illetve stancforma használata esetén,
        kérjük ezeket a rétegeket direkt színként (külön színkivonaton) megadni.
      </p>

      <p>
        <b>Oldalak:</b><br>
        Az oldalakat vágójelekkel, passzerjelekkel és szükség esetén hajtás-, bígelés-,
        perforálás-jelekkel kérjük leadni. (vágás, riccelés: folyamatos vonal, hajtás:
        szaggatott vonal, perforálás: pontvonal)<br>

        Több oldalas anyagok, prospektusok leadásakor a belíveket és
        a borítót külön file-ban kérjük.
        A borító oldalait (B4-B1 borító külső oldal, B2-B3 belső oldal) oldalpárban,
        a belíveket oldalanként, tehát nem oldalpárban egyetlen egy file-ban kérjük.
        Ha a kiadvány üres oldalt tartalmaz,
        az a leadott állományban is a megfelelő helyen szerepeljen.<br>
        Ragasztókötés esetén a gerinc és az esetleges nyitó bígelés méretét a borító
        oldalpár méretébe bele kell számolni. Irkafűzés esetén az oldalak
        számának 4-gyel oszthatónak kell lennie.
      </p>

      <p>
        <b>Adathordozók, állományküldés:</b><br>
        Minden elterjedtebb file formátumot tudunk fogadni és felhasználni,
        e-mailen (15 MB), FTP-n, CD-n, DVD-n, USB eszközön keresztül,
        Macintosh és PC platformra.<br>
        Fogadott adathordozók: CD, DVD, Pen Drive, USB-s külső merevlemez<br>
        Internetes anyagleadás: E-mail, FTP (elérhetőségünket e-mailban küldjük el)<br>
        vagy fájl küldő internetes oldalak
        (pl.
        <a
          href="http://www.toldacuccot.hu/"
          target="_blank"
        >
          www.toldacuccot.hu
        </a>,
        <a
          href="https://wetransfer.com/"
          target="_blank"
        >
          www.wetransfer.com
        </a>
        )
      </p>
    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'MaterialDelivery',
  metaInfo: {
    title: 'Anyagleadás | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: 'Tekintse meg anyagleadási útmutatónkat.',
      },
    ],
  },
  components: {
    ThePageHeader,
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}
</style>
